import { Controller } from '@hotwired/stimulus';
import './component.scss';

export default class extends Controller {
  static targets = ['toggleAll', 'checkbox'];

  connect() {
    this.updateToggleAllState();
  }

  toggleAll(event) {
    const isChecked = event.target.checked;
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = isChecked;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateToggleAllState() {
    if (this.hasToggleAllTarget && this.hasCheckboxTarget) {
      const allChecked = this.checkboxTargets.every(
        (checkbox) => checkbox.checked
      );
      const someChecked = this.checkboxTargets.some(
        (checkbox) => checkbox.checked
      );

      this.toggleAllTarget.checked = allChecked;
      this.toggleAllTarget.indeterminate = someChecked && !allChecked;
    }
  }

  updateToggleAllOnCheckboxChange() {
    this.updateToggleAllState();
  }
}
